import Type from 'components/Type'
import Button from 'components/Button'
import ModalView from 'components/CommonUI/ModalView'
import Stack from '@mui/material/Stack'
import { useAuth0 } from '@auth0/auth0-react'

const SessionTimeoutWarning = () => {
  const { getAccessTokenSilently, logout, isAuthenticated } = useAuth0()

  const handleLogout = () => {
    logout({ returnTo: window.location.origin })
  }

  return (
    <ModalView sizeX="md" preventClose>
      <Stack display="grid" justifyItems="center" textAlign="center" p={3}>
        <Type variant="sectionLabel" mb={1}>
          Session timeout warning
        </Type>
        <Type variant="p" mb={3}>
          Your session has expired due to inactivity.
        </Type>
        <Button outlined onMouseUp={handleLogout}>
          Start a new session
        </Button>
      </Stack>
    </ModalView>
  )
}

export default SessionTimeoutWarning
